import * as Yup from 'yup';
import { printAction } from "../../../../actions";
import { PRINT } from "../../../../consts/methods.consts";


const FacilityCommentsReportConfig = {
    searchApi: 'xceed.api.report.module_evaluation.get_facility_comments_report',
    alert: 'Reminder: Specify a program coordinator to receive reports.',
    excelFileName: 'module-wise-facility-comments-report',
    title: 'Facility Comments Report',
    // extraActionsAsMenu: true,
    pagination: false,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: 'Program Coordinator',
                    key: 'p_coordinator',
                    type: 'form-online-search',
                    methodBody: {},
                    optionMethod: 'xceed.api.report.module_evaluation.get_program_coordinators',
                    validationSchema: Yup.string().required('Program is required'),
                    onChange: (formik: any) => {
                        if (!formik.values.program) {
                            formik.setFieldValue('program', '')

                        }
                    }
                },
                {
                    label: 'Program',
                    key: 'program',
                    type: 'form-online-search',
                    methodBody: { "p_coordinator": "p_coordinator" },
                    optionMethod: 'xceed.api.report.module_evaluation.get_related_programs',
                    disabledBaseOn: ["p_coordinator"],
                    onChange: (formik: any) => {
                        if (!formik.values.program) {
                            formik.setFieldValue('module', '')

                        }
                    }
                },
                {
                    label: 'Module',
                    key: 'module',
                    type: 'form-online-search',
                    methodBody: { "program": "program" },
                    optionMethod: 'xceed.api.report.module_evaluation.get_related_modules',
                    disabledBaseOn: ["p_coordinator", "program"],

                },
            ]
        }],

    tableConfig: {
        column: [
            {
                header: "S/N",
                accessor: "sn",
                width: 10
            },
            {
                header: "Program",
                accessor: "program_title",
                width: 300
            },
            {
                header: "Module",
                accessor: "program_module_title",
                width: 300
            },
            {
                header: "Comments or Suggestions",
                accessor: "comments_on_slida_facilities",
                width: 400
            },
        ]
    },
    actions: [

        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program && filter.p_coordinator) {
                    setLoading(true)
                    setLoading(true);
                    try {
                        await printAction(PRINT.PRINT_MODULE_WISE_FACILITY_COMMENTS_REPORT, { filter }, setLoading);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to print report");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                }
                else {
                    const error: any = new Error('Please select program coordinator , program and module');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]
}

export default FacilityCommentsReportConfig